export class HomeAwayScore {
	/**
	 * This will be null if home competitor score is 0
	 */
	home?: number;
	/**
	 * This will be null if away competitor score is 0
	 */
	away?: number;
}